(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.querySelectorAll('.tag-filter-group').forEach((group) => {
 const input = group.querySelector('.filter-group-search');
 const toggle = group.querySelector('.filter-show-all');
 const empty = group.querySelector('.filter-no-results');
 const options = [...group.querySelectorAll('[data-filter-option]')];
 let expanded = false;
 const render = () => {
  const query = input.value.trim().toLowerCase();
  let matches = 0;
  options.forEach((option, index) => {
   const match = option.textContent.toLowerCase().includes(query);
   if (match) matches++;
   option.hidden = query ? !match : !(expanded || index < 4 || option.classList.contains('is-selected'));
  });
  empty.hidden = matches > 0;
  toggle.hidden = Boolean(query) || options.length <= 4;
  toggle.setAttribute('aria-expanded', String(expanded));
  toggle.innerHTML = expanded ? 'Show less <span aria-hidden="true">⌃</span>' : 'Show all (' + options.length + ') <span aria-hidden="true">⌄</span>';
 };
 input.addEventListener('input', render);
 input.addEventListener('keydown', (event) => { if (event.key === 'Enter') event.preventDefault(); });
 toggle.addEventListener('click', () => { expanded = !expanded; render(); });
 render();
});

  } catch(e) { console.error(e); }
})();
})();
